module.exports = __webpack_public_path__ + "img/HRV-logo.e2c47a2a.png";